export default __webpack_public_path__ + "static/media/check-in-banner-cn.78a2c157.webp";